export class BrowserConnectionServiceJavaScript {
    constructor() {
        Object.defineProperty(this, "browserConnectionServiceInteropHandler", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    Initialize(jSRuntimeBrowserConnectionStatusServiceDotNetObject) {
        console.log("Initializing the BrowserConnectionService");
        this.browserConnectionServiceInteropHandler = function () {
            const value = navigator.onLine;
            console.log("Calling BrowserConnectionService because the navigator.onLine changed to", value);
            jSRuntimeBrowserConnectionStatusServiceDotNetObject.invokeMethodAsync("BrowserConnectionServiceJavaScript.SetConnectionStatus", value);
        };
        window.addEventListener("online", this.browserConnectionServiceInteropHandler);
        window.addEventListener("offline", this.browserConnectionServiceInteropHandler);
        this.browserConnectionServiceInteropHandler();
    }
    Dispose() {
        if (this.browserConnectionServiceInteropHandler) {
            window.removeEventListener("online", this.browserConnectionServiceInteropHandler);
            window.removeEventListener("offline", this.browserConnectionServiceInteropHandler);
        }
    }
}
